import { FormEvent, useState } from "react";

import Icon from "@/components/shared/Icon";
import { useQuickSearchNavigate } from "@/hooks/useQuickSearchNavigate";
import type { QuickSearchIdType } from "@/hooks/useQuickSearchNavigate";

import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

export default function QuickSearch() {
  const { navigateToId, showToast, setShowToast, toastMsg } =
    useQuickSearchNavigate();

  const [searchType, setSearchType] = useState<QuickSearchIdType>("CSPPID");
  const [searchTerm, setSearchTerm] = useState("");

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    if (!searchTerm.trim()) return;

    navigateToId(searchType, searchTerm);
    setSearchTerm("");
  };

  return (
    <>
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 2000 }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
          className="toastErrorCard"
        >
          <div className="toastErrorInner">
            <div className="toastErrorStrip" />

            <div className="toastErrorMain">
              <div className="toastErrorIcon">
                <i className="bi bi-x-circle-fill" />
              </div>

              <div className="toastErrorText">
                <div className="toastErrorTitle">Error</div>
                <div className="toastErrorMessage">{toastMsg}</div>
              </div>

              <button
                type="button"
                className="btn-close ms-auto"
                aria-label="Close"
                onClick={() => setShowToast(false)}
              />
            </div>
          </div>
        </Toast>
      </ToastContainer>

      <div>
        <p className="h5 mb-1 quickSearchTitle">Quick Search</p>

        <form className="form" onSubmit={handleSubmit}>
          <div className="mb-2">
            <label
              htmlFor="quickSearchType"
              className="form-label sidebar-search"
            >
              Search for
            </label>
            <select
              className="form-select"
              id="quickSearchType"
              value={searchType}
              onChange={(e) =>
                setSearchType(e.target.value as QuickSearchIdType)
              }
            >
              <option value="CSPPID">CSPPID</option>
              <option value="CICN">CICN</option>
              <option value="SEID">SEID</option>
              <option value="Staff Local ID">Staff Local ID</option>
              <option value="Classroom ID">Classroom ID</option>
            </select>
          </div>

          <div>
            <label
              htmlFor="quickSearchTerm"
              className="form-label sidebar-search"
            >
              Search term
            </label>

            <div className="d-flex">
              <input
                id="quickSearchTerm"
                className="form-control flex-grow-1"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <button className="btn btn-primary search-btn" type="submit">
                <Icon name="chevron-right" />
                <span className="visually-hidden">Submit search</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
